import useSWR from 'swr'
import AWSConfig from '../cfg/aws-config.json';
import { getCaseS3Credentials } from './cases3credentials'
import AWS from 'aws-sdk';

const region = AWSConfig.default_region

// A pre-signed URL is re-minted periodically (see REFRESH_INTERVAL_MS). The expiry
// must comfortably exceed that interval so a URL already handed to a consumer never
// goes stale before its replacement arrives. Stated explicitly rather than inherited
// from the SDK default (900s) so the margin is visible at the call site.
const SIGNED_URL_EXPIRY_SECONDS = 60 * 15; // 15 minutes
const REFRESH_INTERVAL_MS = 60 * 4 * 1000; // 4 minutes

const getSignedUrl = async (bucketName, key) => {


    // console.log(`getting signed URL for S3 Key:${key}`)

    const caseCredentialsResponse = await getCaseS3Credentials()

    if (caseCredentialsResponse == null) {
        throw new Error('Could not get credentials to upload files')
    }
    const credentials = caseCredentialsResponse.Credentials


    const s3 = new AWS.S3({
        apiVersion: "latest",
        region: region,
        credentials: {
            accessKeyId: credentials.AccessKeyId,
            secretAccessKey: credentials.SecretAccessKey,
            sessionToken: credentials.SessionToken,
        },
    });








    const params = {
        Bucket: bucketName,
        Key: key,
        Expires: SIGNED_URL_EXPIRY_SECONDS,
    };

    const signedUrl = await s3.getSignedUrlPromise('getObject', params);
    return signedUrl


}

export default function useGetSignedUrl(bucketName, key, shouldFetch = true) {
    // console.log(`useGetSignedUrl bucketName=${bucketName} key=${key} shouldFetch=${shouldFetch}`)
    // Every revalidation mints a BRAND-NEW URL string for the SAME S3 object. That
    // used to reload the PDF viewer back to page 1 mid-review (Trello IYmLT1Pl);
    // the viewers now key on stable document identity (stableDocumentKeyFromUrl),
    // so URL churn is harmless — the 4-minute timer has churned it all along.
    //
    // Focus/reconnect revalidation is ON because the timer alone cannot keep the
    // URL fresh: SWR pauses it while the tab is hidden (and the machine may sleep),
    // so a reviewer returning after 15+ minutes held an expired URL for up to
    // another 4 minutes, and any uncached document they opened 403'd in the viewer
    // (Trello nvr3sZfx). dedupingInterval keeps this cheap — a focus within 4
    // minutes of the last signing reuses the current URL.
    const result = useSWR(
        shouldFetch ? ['SIGNEDURL', bucketName, key] : null,
        ([tag, bucketName, key]) => getSignedUrl(bucketName, key),
        {
            refreshInterval: REFRESH_INTERVAL_MS,
            revalidateOnFocus: true,
            revalidateOnReconnect: true,
            dedupingInterval: REFRESH_INTERVAL_MS,
        }
    );
    return result;
}